import Api from "../services/Admin";

// --- Public
const getToken = () => {
  return sessionStorage.getItem("Token");
};

const getUser = () => {
  return JSON.parse(sessionStorage.getItem("User"));
};

const setData = (token, user) => {
  sessionStorage.setItem("Token", token);
  sessionStorage.setItem("User", JSON.stringify(user));
};

const checkToken = () => Api.CheckToken();

const logout = () => {
  sessionStorage.removeItem("Token");
  sessionStorage.removeItem("User");
};

export default { setData, getUser, getToken, checkToken, logout };



// WEBPACK FOOTER //
// ./src/libs/AdminSession.js